// "NBA Fantasy - Salary Cap" category id on content-api-prod.nba.com
const NewsCategoryID = "52592";

export interface INewsItem {
  id: number;
  title: string;
  excerpt: string;
  permalink: string;
  featuredImage: string;
}

export interface INewsApiResponse {
  results: {
    count: number;
    items: INewsItem[];
    total: number;
  };
}

export const NewsFeedLink =
  "https://www.nba.com/news/category/nba-fantasy-salary-cap";

export const getNewsFeedUrl = (numberOfArticles: number): string => {
  const params = new URLSearchParams({
    page: "1",
    count: String(numberOfArticles),
    types: "post",
    "term-category": NewsCategoryID,
    region: "international",
  });
  return `https://content-api-prod.nba.com/public/1/leagues/nba/content?${params.toString()}`;
};
